var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsDownFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1408 9.00602L16.297 2.25602C16.2376 1.77987 16.0063 1.34184 15.6466 1.02424C15.2869 0.706632 14.8236 0.531321 14.3438 0.53125H2.25C1.87704 0.53125 1.51935 0.679408 1.25563 0.943131C0.991908 1.20685 0.84375 1.56454 0.84375 1.9375V8.125C0.84375 8.30967 0.880124 8.49253 0.950794 8.66315C1.02147 8.83376 1.12505 8.98879 1.25563 9.11937C1.38621 9.24995 1.54124 9.35353 1.71185 9.4242C1.88247 9.49488 2.06533 9.53125 2.25 9.53125H5.10328L7.68305 14.6901C7.75314 14.8302 7.86084 14.9479 7.99409 15.0303C8.12733 15.1126 8.28087 15.1562 8.4375 15.1562C9.25773 15.1553 10.0441 14.8291 10.6241 14.2491C11.2041 13.6691 11.5303 12.8827 11.5312 12.0625V11.2188H15.1875C15.4666 11.2187 15.7425 11.1593 15.9969 11.0445C16.2514 10.9297 16.4785 10.7621 16.6632 10.5529C16.8479 10.3436 16.986 10.0975 17.0683 9.83082C17.1507 9.56413 17.1754 9.28298 17.1408 9.00602Z",
    fill: "#053F98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownFilled);
export default __webpack_public_path__ + "static/media/ThumbsDownFilled.70951fde541e610524a70757870a0926.svg";
export { ForwardRef as ReactComponent };